import React, { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { Loading, TitleController } from '@pandiafi/design-system'

import { BulletinViewDataLoader } from './BulletinViewDataLoader'
import { ErrorHandler } from './BulletinViewErrorHandler'

import { View } from 'components'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import { Bulletin } from 'components/Bulletin/Bulletin'

export const BulletinView: React.FC = () => {
  const { t } = useTranslation(['common', 'titles', 'documents'])
  const { frontPagePath } = useContractPaths()

  return (
    <TitleController title={t('titles:bulletin')}>
      <View>
        <View.Header>
          <View.HeaderLink to={frontPagePath}>
            {t('common:views.home')}
          </View.HeaderLink>

          <View.HeaderTitle>{t('common:views.bulletin')}</View.HeaderTitle>
        </View.Header>

        <View.Sidebar />

        <View.Content>
          <Suspense fallback={<Loading variant="details" />}>
            <ErrorHandler>
              <BulletinViewDataLoader>
                {({ bulletin, onLanguageChange }) => (
                  <Bulletin
                    bulletin={bulletin}
                    onLanguageChange={onLanguageChange}
                  />
                )}
              </BulletinViewDataLoader>
            </ErrorHandler>
          </Suspense>
        </View.Content>
      </View>
    </TitleController>
  )
}
